import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import React, { useState } from 'react';

import FormInputText, { IFormInputText } from './FormInputText';

const PasswordField = (props: IFormInputText) => {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <FormInputText
      {...props}
      type={showPassword ? 'text' : 'password'}
      TextFieldProps={{
        InputProps: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onMouseDown={() => setShowPassword(!showPassword)}>
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          )
        }
      }}
    />
  );
};

export default PasswordField;
